import React from 'react';
import withIconProps from './utils/withIconProps';

const SvgLoadingSpin = ({ title, ...props }) => (
  <svg
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    className="loading-spin_svg__lds-rolling"
    style={{
      background: '0 0',
    }}
    aria-labelledby="title"
    role="img"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <circle
      stroke="#31363e"
      strokeWidth={16}
      r={36}
      cx={50}
      cy={50}
      fill="none"
      strokeDasharray="169.64600329384882 58.548667764616276"
      transform="rotate(127.12 50 50)"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        calcMode="linear"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
        dur="0.8s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

SvgLoadingSpin.displayName = 'Loading Spin';
export default withIconProps(SvgLoadingSpin);
